<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="false"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        tipoEquipe="emulti"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="false"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        tipoEquipe="emulti"
      />
    </div>

    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Pessoas" active>
          <template #title> <i class="icofont-list"></i> Pessoas </template>
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed"
                :setGreen="exibirCadastrosVerdes"
              />
            </div>
            <div class="info-table-item">
              <SelectMes v-model="mes" />
            </div>
            <div class="info-table-item">
              <DownloadFiles
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFieldsExport"
                name="pessoas-atendidas"
              />
            </div>
          </div>
          <TabelaCadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            :mes="mes"
            @filterSearch="filterSearch"
          />
        </b-tab>

        <b-tab title="Percentual">
          <template #title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <TabelaPercentual
            :loading="loading"
            :municipio="dadosPercentualMunicipio"
            :equipe="dadosPercentualEquipe"
            :micro_area="dadosPercentualMicroArea"
            :selectedEquipe="equipe"
            :selectedMicroArea="microArea"
            :tipoResultado="tipoResultadoPercentual"
            @changeTipoResultado="changeTipoResultadoPercentual"
          />
          <GraficoPercentual
            :equipe="equipe"
            :micro_area="microArea"
            :tipoResultado="tipoResultadoGrafico"
            @changeTipoResultado="changeTipoResultadoGrafico"
            ref="graficoPercentual"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Subtitle from './components/Subtitle.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './components/TabelaCadastros.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaPercentual from './components/TabelaPercentual.vue'
import GraficoPercentual from './components/GraficoPercentual.vue'
import { getDataFields } from './utils.js'
import SelectMes from '../../components/SelectMes.vue'

export default {
  name: 'MediaAtendimentosPorPessoa',
  components: {
    Subtitle,
    PulseLoader,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    TabelaCadastros,
    SelectsV2,
    TabelaPercentual,
    GraficoPercentual,
    SelectMes,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      microArea: '',
      microAreas: [],
      cadastros: [],
      cadastrosOriginais: [],
      dadosPercentualMunicipio: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualEquipe: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualMicroArea: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosTabelaPercentual: [],
      dadosGraficoPercentual: [],
      loading: false,
      tabsActive: 0,
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      filterSearchTable: false,
      mes: null,
      tipoResultadoPercentual: 'quadrimestral',
      tipoResultadoGrafico: 'quadrimestral',
    }
  },

  computed: {
    displayedCadastros() {
      if (this.filterSearchTable) return this.filterSearchTable

      const resultado = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.equipe,
        this.mes
      )
      return resultado || []
    },
    dataFieldsExport() {
      return getDataFields(this.mes)
    },
  },
  watch: {
    mes(valor) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.filterSearchTable = false

      if (valor) {
        this.handleExibirVerdes(true)
      }
    },
  },
  methods: {
    /**
     * Habilita os filtros vermelho/verde
     *
     * @param {Boolean} vermelho
     * @param {Boolean} verde
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.setRed = vermelho
      this.exibirCadastrosVermelhos = vermelho
      this.exibirCadastrosVerdes = verde && !vermelho
    },

    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      this.filterSearchTable = item.filter || false
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} valor Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(valor) {
      this.filtros(valor, false)
      this.mes = null
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} valor Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(valor) {
      this.filtros(false, valor)
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) this.$refs.table.search = ''

      this.equipe = {
        ine_esf_eap: event.ine_esf_eap,
        ine_emulti: event.ine_emulti,
        no_equipe: event.no_equipe,
      }

      this.microArea = ''
      this.mes = null
      this.resetDadosMicroArea()

      if (event) {
        this.tabsActive = 0
        this.resetCadastros()
        await this.buscarCadastrosPorEquipe()
      } else {
        this.resetDadosEquipe()
        this.resetCadastros()
      }

      this.setarPercentualEquipe()
    },

    /**
     * Manipula a alteração da microárea selecionada.
     *
     * @param {Object} event Microárea selecionada
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.tabsActive = 0
      this.microArea = event?.micro_area || ''
      this.mes = null
      this.resetDadosMicroArea()

      if (event && this.microArea) {
        this.loading = true
        await this.buscarCadastrosMicroArea()
        this.loading = false
      } else {
        await this.onChangeEquipe(this.equipe)
      }

      this.setarPercentualMicroArea()
    },

    /**
     * Buscar os cadastros por equipe
     */
    async buscarCadastrosPorEquipe() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.ine_emulti
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
      }
      this.loading = false
    },

    /**
     * Buscar os cadastros por microárea
     */
    async buscarCadastrosMicroArea() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorMicroArea(
        this.$store.state.cod_ibge,
        this.equipe.ine_emulti,
        this.microArea
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
      }
      this.loading = false
    },

    /**
     * Calcula e atualiza o percentual do município no gráfico.
     */
    setarPercentualMunicipio() {
      const resultado = Functions.percentualMunicipio(
        this.dadosGraficoPercentual,
        this.tipoResultadoPercentual
      )
      Object.assign(this.dadosPercentualMunicipio, resultado)
      this.$refs.graficoPercentual.serieHistoricaMunicipio(
        this.dadosGraficoPercentual
      )
    },

    /**
     * Calcula e atualiza o percentual da equipe no gráfico.
     */
    setarPercentualEquipe() {
      const resultado = Functions.percentualEquipe(
        this.dadosGraficoPercentual,
        this.equipe.ine_emulti,
        this.tipoResultadoPercentual
      )
      Object.assign(this.dadosPercentualEquipe, resultado)
      this.$refs.graficoPercentual.serieHistoricaEquipe(
        this.dadosGraficoPercentual,
        this.equipe
      )
    },

    /**
     * Calcula e atualiza o percentual da microárea no gráfico.
     */
    async setarPercentualMicroArea() {
      if (!this.microArea) return
      const resultado = Functions.percentualMicroArea(
        this.dadosGraficoPercentual,
        this.equipe.ine_emulti,
        this.microArea,
        this.tipoResultadoPercentual
      )
      Object.assign(this.dadosPercentualMicroArea, resultado)
      // this.$refs.graficoPercentual.serieHistoricaMicroArea(
      //   this.dadosGraficoPercentual,
      //   this.equipe,
      //   this.microArea
      // )
    },

    /**
     * Limpa os dados de cadastros da tela.
     */
    resetCadastros() {
      this.cadastros = []
      this.cadastrosOriginais = []
    },

    /**
     * Reseta os dados e percentuais da equipe selecionada.
     */
    resetDadosEquipe() {
      this.equipe = ''
      this.dadosPercentualEquipe = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    /**
     * Reseta os dados e percentuais da microárea selecionada.
     */
    resetDadosMicroArea() {
      this.dadosPercentualMicroArea = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    /**
     * Altera o tipo de resultado da tabela percentual.
     *
     * @param {String} tipo Tipo do resultado (mensal ou quadrimestral).
     */
    changeTipoResultadoPercentual(tipo) {
      this.tipoResultadoPercentual = tipo

      this.setarPercentualMunicipio()

      if (this.equipe) {
        this.setarPercentualEquipe()
      }

      if (this.microArea) {
        this.setarPercentualMicroArea()
      }
    },

    /**
     * Altera o tipo de resultado do gráfico.
     *
     * @param {String} tipo Tipo do resultado (mensal ou quadrimestral).
     */
    changeTipoResultadoGrafico(tipo) {
      this.tipoResultadoGrafico = tipo

      this.$nextTick(() => {
        this.$refs.graficoPercentual.serieHistoricaMunicipio(
          this.dadosGraficoPercentual
        )

        if (this.equipe) {
          this.$refs.graficoPercentual.serieHistoricaEquipe(
            this.dadosGraficoPercentual,
            this.equipe
          )
        }

        if (this.microArea) {
          this.$refs.graficoPercentual.serieHistoricaMicroArea(
            this.dadosGraficoPercentual,
            this.equipe,
            this.microArea
          )
        }
      })
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.microArea,
        this.mes
      )
    },

    /**
     * Inicializa os dados
     */
    async init() {
      try {
        const response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[44]`
        )
        this.dadosGraficoPercentual = response2.data
        this.setarPercentualMunicipio()
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let nu_ine_profissional =
            this.$store.state.id_funcao == 8 ||
            this.$store.state.id_funcao == 14 ||
            this.$store.state.id_funcao == 15
              ? this.$store.state.nu_ine_vinculada
              : this.$store.state.nu_ine

          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == nu_ine_profissional
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              ine_emulti: equipe.ine_emulti,
              no_equipe: equipe.no_emulti,
            }
            this.buscarCadastrosPorEquipe()
            this.setarPercentualEquipe()
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              ine_emulti: equipe.ine_emulti,
              no_equipe: equipe.no_emulti,
            }
            this.setarPercentualEquipe()
          }
          this.microArea = this.$store.state.micro_area
          this.buscarCadastrosMicroArea()
          this.setarPercentualMicroArea()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style scoped></style>
